/**
 *
 *  NCT-TIS-Data Configuration
 *  -------------------------------------
 *
 */

// Set debug mode automatically when in Node or when in localhost
const devMode = typeof window === 'undefined' || (window && window.location.href.indexOf('localhost') !== -1)
const productionMode = !devMode

module.exports = {
    production: productionMode, // If true, Json file will be compressed

    /******************************
     * Import settings
     */
    import: {
        compress: true,
        metaFile: 'meta.json',
        validityFile: 'validities.json',
        htmlPath: '',
    },

    /******************************
     * Common settings
     */
    getImportPath: (portal, platform) => {
        return `media/Import/data/${portal}/${platform}/languages`;
    },

    getPortalImportPath: (portal) => {
        return `media/Import/data/${portal}`;
    },
    
    mediaPaths: {
        vcc: 'media/vcc',
        polestar: 'media/polestar'
    },
    subtitlePath: 'Import/subtitles',
    htmlDirname: 'topics',
    syncIndexFilename: 'sync-index.json',
    nodesFilename: 'categories.json',
    topicsFilename: 'topics.json',
    releaseNotesFilename: 'releaseNotes.json',
    relatedFilename: 'related.json',
    validitiesFilename: 'validities.json',
    emptyOnNewImport: false, // Will clear all old topics from topics.json (index file)

    /******************************
     * Client interface
     */
    searchMinChars: 1,
    searchDebounceTime: 350, // Not used atm
    searchParamName: 'search',
    processTime: 350, // Fake process time

    topicBasketLimit: 50, // Max number of topics in Document Basket

    validityDomains: {
        market: 'market',
        model: 'model',
        structureWeek: 'structure-week',
        gearboxes: 'gearbox',
        propulsion: 'propulsion',
        electricCapacity: 'electric-capacity',
        electricPowertrain: 'electric-powertrain',

        // We use this when searching for HTML validity data properties
        checkDomains: [
            'market',
            'model',
            'structure-week',
            'gearbox',
            'propulsion',
            'electric-capacity',
            'electric-powertrain',
        ]
    },
    
    releaseNotesFunctionId: [
        'd385d89be656f9a3c0a8830141e156ee', // VCC
        // 'd385d89be656f9a3c0a8830141e156ee'
    ],

    baseUrl: '/' // TEMPORARY
}
